import React, { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import SidebarNav from "./SidebarNav";
import useAuth from "../hooks/useAuth";
import TopBar from "./TopBar";
import NotificationBar from "../components/NotificationBar";
import { LayoutProvider } from "../context/LayoutContext";
import { useCurrentUser } from "../hooks/useCurrentUser";

const excludeNavbarPaths = ["/forgotPassword", "/resetPassword", "/otp"];

export const Layout = () => {
  const { isAuthenticated } = useAuth();
  const { userData } = useCurrentUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const location = useLocation();
  const blockedPaths = [
    "/login",
    "/otp",
    "/forgotPassword",
    "/resetPassword",
    "/clientSignup",
    "/customerSignup",
    "/getStarted",
    "/techSignup",
  ];

  if (isAuthenticated && blockedPaths.some((path) => location.pathname.startsWith(path))) {
    return <Navigate to="/" replace />;
  }

  return (
    <LayoutProvider>
      <main className="bg-white ">
        {isAuthenticated ? (
          <div className="flex justify-center">
            <SidebarNav
              userData={userData}
              isSidebarOpen={isSidebarOpen}
              onClose={() => setIsSidebarOpen(false)}
            />
            <NotificationBar />
            {/* min-w-0: without it this flex item cannot shrink below the
                min-content width of a wide child (e.g. the bank accounts data
                grid), which widens the centred row and pushes the sidebar off
                the left edge. */}
            <div className="relative min-w-0 2xl:w-[96.2%] xl:w-[93.2%] lg:w-[91%] md:w-[87.5%] sm:w-[95%] w-full xl:ml-[96px] sm:ml-[96px] m-0 ">
              <TopBar userData={userData} onMenuToggle={() => setIsSidebarOpen((prev) => !prev)} />
              <Outlet />
            </div>
          </div>
        ) : (
          <Outlet />
        )}
      </main>
    </LayoutProvider>
  );
};
